/*
 * LIMTEH: cap the product quantity selector at the variant's stock.
 *
 * Impulse's quantity control (theme.QtySelector) has no upper bound — "+"
 * counts up forever and Shopify only complains at add-to-cart. This script
 * reads the per-variant stock caps the product template prints next to the
 * selector (variants tracked by Shopify with "deny" when out of stock; other
 * variants have no cap), clamps the box, and disables "+" at the limit. The
 * Personalise block sets the quantity from a saved design the same way a
 * customer would, so that is clamped too.
 *
 * Vanilla ES2018, no dependencies, safe to include more than once.
 */
(function () {
  'use strict';
  if (window.__ltdQtyCap) return;
  window.__ltdQtyCap = true;

  var WRAPPER = '.js-qty__wrapper';
  var INPUT = '.js-qty__num';
  var PLUS = '.js-qty__adjust--plus';
  var CAPS = 'script[data-ltd-stock-caps]';
  var FORM = 'form[action*="/cart/add"]';
  var NOTE_CLASS = 'ltd-qty-cap__note';

  function warn(e) {
    try { if (window.console && console.warn) console.warn('[ltd-qty-cap]', e); } catch (x) { /* noop */ }
  }

  /* The caps JSON that belongs to this selector: nearest one inside the same
     product block, else the same section. */
  function capsFor(wrapper) {
    var scope = wrapper.closest('.product__quantity') || wrapper.closest('.shopify-section') || document;
    var el = scope.querySelector(CAPS);
    if (!el) return null;
    if (el.__ltdCaps) return el.__ltdCaps;
    try {
      el.__ltdCaps = JSON.parse(el.textContent || '{}') || {};
    } catch (e) {
      warn(e);
      el.__ltdCaps = {};
    }
    return el.__ltdCaps;
  }

  function currentVariantId(wrapper, input) {
    var form = null;
    try {
      var formId = input.getAttribute('form');
      if (formId) form = document.getElementById(formId);
      if (!form) form = wrapper.closest(FORM);
      if (!form) {
        var section = wrapper.closest('.shopify-section');
        form = section ? section.querySelector(FORM) : null;
      }
    } catch (e) {
      warn(e);
    }
    var idInput = form ? form.querySelector('[name="id"]') : null;
    return idInput ? String(idInput.value) : null;
  }

  /* Stock cap for the selected variant, or null when it is not capped. */
  function capFor(wrapper, input) {
    var caps = capsFor(wrapper);
    if (!caps) return null;
    var id = currentVariantId(wrapper, input);
    if (!id || !Object.prototype.hasOwnProperty.call(caps, id)) return null;
    var n = parseInt(caps[id], 10);
    return isNaN(n) ? null : n;
  }

  function note(wrapper, text) {
    var el = wrapper.parentNode ? wrapper.parentNode.querySelector('.' + NOTE_CLASS) : null;
    if (!text) {
      if (el) el.remove();
      return;
    }
    if (!el) {
      el = document.createElement('p');
      el.className = NOTE_CLASS;
      el.setAttribute('role', 'status');
      wrapper.insertAdjacentElement('afterend', el);
    }
    if (el.textContent !== text) el.textContent = text;
  }

  function apply(wrapper) {
    var input = wrapper.querySelector(INPUT);
    var plus = wrapper.querySelector(PLUS);
    if (!input || !plus) return;
    var cap = capFor(wrapper, input);
    if (cap === null) {
      input.removeAttribute('max');
      plus.disabled = false;
      plus.classList.remove('is-capped');
      note(wrapper, '');
      return;
    }
    /* Sold out: the theme disables Add to cart; keep the box at 1 so it is
       not stuck at 0 if stock comes back on a variant switch. */
    var limit = Math.max(1, cap);
    input.setAttribute('max', String(limit));
    var qty = parseInt(input.value, 10);
    if (!qty || qty < 1) qty = 1;
    if (qty > limit) {
      input.value = String(limit);
      qty = limit;
    }
    var atCap = qty >= limit;
    plus.disabled = atCap;
    plus.classList.toggle('is-capped', atCap);
    note(wrapper, atCap && cap > 0 ? (cap === 1 ? 'Only 1 available' : 'Only ' + cap + ' available') : '');
  }

  function applyAll() {
    var wrappers = document.querySelectorAll(WRAPPER);
    for (var i = 0; i < wrappers.length; i++) {
      try {
        if (capsFor(wrappers[i])) apply(wrappers[i]);
      } catch (e) {
        warn(e);
      }
    }
  }

  function schedule() {
    window.setTimeout(applyAll, 0);
  }

  /* "+" at the cap: stop the theme's own handler (which would add one) before
     it runs. Capture phase on document runs ahead of the button's listener. */
  document.addEventListener('click', function (e) {
    var plus = e.target && e.target.closest ? e.target.closest(PLUS) : null;
    if (!plus) return;
    var wrapper = plus.closest(WRAPPER);
    if (!wrapper) return;
    var input = wrapper.querySelector(INPUT);
    if (!input) return;
    var cap = capFor(wrapper, input);
    if (cap === null) return;
    var qty = parseInt(input.value, 10) || 1;
    if (qty >= Math.max(1, cap)) {
      e.preventDefault();
      e.stopImmediatePropagation();
      apply(wrapper);
    } else {
      schedule();
    }
  }, true);

  /* Typed values, the "−" button, the theme's variant radios/select, and the
     Personalise block writing a saved design's quantity all end in a change
     or input event; clamp after the theme has reacted. */
  document.addEventListener('change', schedule);
  document.addEventListener('input', schedule);
  document.addEventListener('variant:change', schedule);

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', applyAll);
  else applyAll();
})();
